import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

import { MultiLanguageUrl } from '../../constants/multiLanguage.constant';

type Props = {
  to: string;
  children: any;
  onClick?: () => void;
};

export default function AuthLinkTo({ children, to, onClick, ...props }: Props | any) {
  const { t, i18n } = useTranslation();
  return (
    <Link
      onClick={() => {
        onClick?.();
      }}
      {...props}
      to={`${window.location.origin}/${MultiLanguageUrl[i18n.language] || 'en-US'}/${to}`}
    >
      {children}
    </Link>
  );
}
